// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2gohU","content":"ManualTimeModal_content__1NYEC"};